import Vue from "vue";
import Vuelidate from "vuelidate";
import registerSingleVehicleModule from "./store/register-single-vehicle";
import gpsQuoteRequestModule from "./store/gps-quote-request";
import {
  registerComponents,
  initI18n,
  Components as CoreComponents
} from "@bvm/core";
import BvmCore from "@bvm/core";
import * as Components from "./components";
import { loadI18n, initialMessages } from "./load-i18n";
import VuexPersistence from "vuex-persist";
import VueI18n from "vue-i18n";
import vueDebounce from "vue-debounce";
import Vuex from "vuex";
import VueScrollTo from "vue-scrollto";
import { customVueFormFields, registerVueFormValidators } from "./vueForm";

import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-getcanonicallocales/polyfill";
import "@formatjs/intl-numberformat/dist/locale-data/en";
import "@formatjs/intl-numberformat/dist/locale-data/nl";
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/dist/locale-data/en";
import "@formatjs/intl-pluralrules/dist/locale-data/nl";

export const init = function(options, locale, currency) {
  Vue.use(Vuex);
  Vue.use(VueI18n);
  Vue.use(vueDebounce);
  Vue.use(Vuelidate);
  Vue.use(VueScrollTo);
  Vue.use(BvmCore, {
    implementerName: "mop"
  });

  // Register global components
  registerComponents(Vue, "Bvm", CoreComponents);
  registerComponents(Vue, "", customVueFormFields);
  registerComponents(Vue, "BvmMop", Components);

  // Register other dependencies
  registerVueFormValidators(Vue);

  // Vue
  const vuexSession = new VuexPersistence({
    storage: window.sessionStorage
  });

  const vue = new Vue({
    store: new Vuex.Store({ plugins: [vuexSession.plugin] }),
    i18n: initI18n(locale, currency, initialMessages(locale)),
    ...options
  });

  // TODO: remove this when the icons from @bvm/style are globally available [BOP-3799]
  require('../src/assets/scss/_icons.scss');

  // IMPORTANT: preserveState=true is required make vuex-persist work with dynamic modules
  // However this will cause Vuex to not load the initial state for that module
  // So it must be disabled initially by checking if the Vuex-persist state has been stored
  // After the state has been by Vuex persist, preserveState should be set to true,
  // to make sure that Vuex persist is able to restore the state.
  const vuexPersistStateIsStored = sessionStorage.getItem("vuex") !== null;
  vue.$store.registerModule(
    "registerSingleVehicle",
    registerSingleVehicleModule,
    { preserveState: vuexPersistStateIsStored }
  );
  vue.$store.registerModule(
    "gpsQuoteRequest",
    gpsQuoteRequestModule,
    { preserveState: vuexPersistStateIsStored }
  );
  loadI18n(vue, locale);
  return vue;
};

window.Bovemij = window.Bovemij || {};
window.Bovemij.mop = window.Bovemij.mop || {};
window.Bovemij.mop.initVue = init;
